import React, { useEffect, useState } from 'react'
import { OverlayTrigger, Button, Modal, Row, Col, Form } from 'react-bootstrap'
import { MdFilterList, MdAddCircle, MdEdit, MdDelete } from 'react-icons/md';
import { Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import loading from '../../assets/images/common/loading.gif';
import axios from 'axios';
import AppDataGrid from '../../components/common/AppDataGrid';
import { ToastContainer, toast } from 'react-toastify';


const Busrouteassignment = () => {
    const [searchQuery, setSearchQuery] = useState("");
    const navigate = useNavigate();
    const [showFilterModal, setShowFilterModal] = useState(false);
    const handleShowFilterModal = () => setShowFilterModal(true);
    const [isLoading, setIsLoading] = useState(true);
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const userData = sessionStorage.getItem('user');
    const handleCloseFilterModal = () => setShowFilterModal(false);
    const userObj = JSON.parse(userData);
    const [Routes, setRoutes] = useState([]);
    const [routers, setRouters] = useState([]);
    const [vehicles, setVehicles] = useState([]);
    const [drivers, setDrivers] = useState([]);
     const [attenders, setAttenders] = useState([]);
    const [form, setForm] = useState({
        route_id: null,
        driver_id:null,
        attendor_id:null,
        vehicle_id:null,

        action: "FILTER"
    });

    const handleInputChange = (e) => {
        const { id, value } = e.target;

        setForm((prevForm) => ({
            ...prevForm,
            [id]: value
        }));
    };
    useEffect(() => {
                 fetchRoutes();
                vehicleData();
                 DriverData();
                 AttenderData();
            }, []);

     const vehicleData = async () => {
                try {
                    const response = await axios.post(baseUrl + "/vehicle/", {
                        action: "READ",
                        school_id: userObj.school_id
                    });
        
                    setVehicles(response.data);
                } catch (error) {
                    console.log("Error fetching data:", error);
                }
            };


            const fetchRoutes = async () => {
                const resp = await axios.get(`${baseUrl}/routes/${userObj.school_id}`, { params: { action: 'READ' } });
                setRouters(resp.data || []);
              };


              const DriverData = async () => {
                          try {
                              const response = await axios.get(baseUrl + "/driversintransport/", {
                                  action: "READ",
                                  school_id: userObj.school_id
                              });
                  
                              setDrivers(response.data);
                          } catch (error) {
                              console.log("Error fetching data:", error);
                          }
                      };
              
                      const AttenderData = async () => {
                          try {
                              const response = await axios.get(baseUrl + "/attenders-in-transport/", {
                                  action: "READ",
                                  school_id: userObj.school_id
                              });
                  
                              setAttenders(response.data);
                          } catch (error) {
                              console.log("Error fetching data:", error);
                          }
                      };

    const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = {
        action: "FILTER",
        school_id: userObj.school_id,
        route_id: form.route_id,
        driver_id: form.driver_id,
        attendor_id: form.attendor_id,
    };

    try {
        const response = await axios.post(baseUrl + "/bus-route-assignment/", formData, {
            headers: {
                "Content-Type": "application/json",
            },
        });

        const data = response.data;

        if (data && typeof data === "object" && data.message === "No data found for action: FILTER") {
            setRoutes([]);
        } else {
            setRoutes(Array.isArray(data) ? data : []);
        }

        setShowFilterModal(false);
    } catch (error) {
        console.error("Error fetching filtered data:", error);
        setRoutes([]);
        setShowFilterModal(false);
    }
};



    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

   const columns = [
    {
    field: 'model',
    headerName: 'Vehicle Name',
    flex: 1,
    renderCell: (params) => (
      <Tooltip title={params.value || ''}><span>{params.value}</span></Tooltip>
    ),
  },
  {
    field: 'route_name',
    headerName: 'Route Name',
    flex: 1,
    renderCell: (params) => (
      <Tooltip title={params.value || ''}><span>{params.value}</span></Tooltip>
    ),
  },
  
  {
    field: 'driver_name',
    headerName: 'Driver Name',
    flex: 1,
    renderCell: (params) => (
      <Tooltip title={params.value || ''}><span>{params.value}</span></Tooltip>
    ),
  },
  {
    field: 'attendor_name',
    headerName: 'Attender Name',
    flex: 1,
    renderCell: (params) => (
      <Tooltip title={params.value || ''}><span>{params.value}</span></Tooltip>
    ),
  },
  {
    field: 'is_active',
    headerName: 'Status',
    flex: 1,
    renderCell: (params) => (
      <Tooltip title={params.value || ''}><span>{params.value}</span></Tooltip>
    ),
  },
  {
    field: 'actions',
    headerName: 'Actions',
    flex: 1,
    sortable: false,
    renderCell: (params) => (
      <div className="tableActions">
        <Tooltip title="Edit">
          <span
            className="commonActionIcons"
            onClick={() => handleEditClick(params.row.bus_route_id)}
          >
            <MdEdit />
          </span>
        </Tooltip>
        <Tooltip title="Delete">
          <span
            className="commonActionIcons"
            onClick={() => handleDeleteClick(params.row.bus_route_id)}
          >
            <MdDelete />
          </span>
        </Tooltip>
      </div>
    ),
  },
];
    const normalized = (v) => (v ?? '').toString().toLowerCase().replace(/[-\s]+/g, '');
    const q = normalized(searchQuery);
    const rows = (Routes || []).filter((r) =>
        [r.route_name, r.start_location, r.end_location, r.estimated_time]
            .some((v) => normalized(v).includes(q))
    );

    const searchableColumns = [
    (row) => row.model || '',
    (row) => row.route_name || '',
    (row) => row.driver_name || '',
    (row) => row.attendor_name || '',
];

    const normalizedQuery = (searchQuery || '').toLowerCase().replace(/[-\s]+/g, '');

    const filteredRecords = (Routes || []).filter((item) =>
    searchableColumns.some((selector) => {
        const value = selector(item).toString().toLowerCase().replace(/[-\s]+/g, '');
        return value.includes(normalizedQuery);
    })
);

    const handleReset = async (e) => {
        e.preventDefault();
        setForm({
            route_name: "",
            model:"",
            driver_name:"",
            attender_name:""
        });
        setShowFilterModal(true);
        fetchData();
    };

    useEffect(() => {
        setIsLoading(true);
        fetchData().finally(() => setIsLoading(false));
    }, []);

    const handleEditClick = (bus_route_id) => {
        const routesmasterToEdit = Routes.find(route => route.bus_route_id === bus_route_id);

        if (routesmasterToEdit) {
            navigate("/addbusassignment", { state: { routesData: routesmasterToEdit } });
        } else {
            console.error(`Routes with ID ${bus_route_id} not found.`);
        }
    };

    const fetchData = async () => {
        try {
            const response = await axios.post(baseUrl + "/bus-route-assignment/", {
                action: "READ",
                school_id: userObj.school_id
            });

            setRoutes(response.data);
        } catch (error) {
            console.log("Error fetching data:", error);
        }
    };

     const handleDeleteClick = async (bus_route_id) => {
        const confirmDelete = window.confirm('Are you sure you want to change the status?');

        if (!confirmDelete) {
            return;
        }
        const requestBody = {
            bus_route_id: bus_route_id,
            action: "DELETE"
        };

        try {
            const response = await axios.post(baseUrl + '/bus-route-assignment/', requestBody, {
                headers: {
                    'Content-Type': 'application/json'
                },
            });
            if (response.status < 200 || response.status >= 300) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            toast.success("Record Set To InActive ");
            fetchData();
        } catch (error) {
            console.error('Error:', error);
        }
    };


    return (
        <div className='pageBody'>
            <ToastContainer />
            <div className='commonDataTableHead'>
                <div className='d-flex justify-content-between align-items-center w-100'>
                    <div className='d-flex align-items-center' style={{ gap: "10px" }}>
                        <h6 className='commonTableTitle'>Bus Route Assignment</h6>
                    </div>
                    <div className="">
                        <input
                            type="text"
                            placeholder="Search..."
                            value={searchQuery}
                            className="searchInput"
                            onChange={handleSearchChange}
                        />
                    </div>
                    <div className="d-flex align-items-center" style={{ gap: 6 }}>
                        <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Filter</Tooltip>}>
                            <Button className="secondaryBtn" variant="secondary" onClick={handleShowFilterModal}>
                                <MdFilterList />
                            </Button>
                        </OverlayTrigger>
                        {
                            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Add</Tooltip>}>
                                <Button className="primaryBtn" variant="primary" onClick={() => navigate("/addbusassignment")}>
                                    <MdAddCircle />
                                </Button>
                            </OverlayTrigger>
                        }
                    </div>
                </div>
            </div>
            <div className='commonTable'>
                <div className="tableBody">
                    {isLoading ? (
                        <div className="loadingContainer">
                            <img src={loading} alt="Loading..." className="loadingGif" />
                        </div>
                    ) : (
                        <AppDataGrid
                         rows={filteredRecords.length ? filteredRecords : []}
                           //rows={rows}
                            columns={columns}
                            getRowId={(row) => row.bus_route_id}
                            pageSizeOptions={[10, 20, 50]}     
                            showToolbar={false}
                            pagination
                            density="compact"
                            maxHeight={550}
                        />
                    )}
                </div>
            </div>
            <Modal show={showFilterModal} onHide={handleCloseFilterModal} className="commonFilterModal">
                <Modal.Header closeButton className="modalHeaderFixed">
                    <Modal.Title>Filter</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col xs={12}>
                                                    <div className='commonInput'>
                                                        <Form.Group controlId="month_name">
                                                            <Form.Label>Vehicle Name</Form.Label>
                                                            <Form.Select
                                                                name="vehicle_id"
                                                                id="vehicle_id"
                                                                value={form.vehicle_id}
                                                                onChange={(e) => setForm({ ...form, vehicle_id: e.target.value })}>
                                                                <option value="">Select Vehicle Name</option>
                                                                {(vehicles || [])
                                                                     .filter((vehicle) => vehicle.status === "Active")
                                                                    .map((vehicle) => (
                                                                        <option key={vehicle.vehicle_id} value={vehicle.vehicle_id}>
                                                                            {vehicle.model}
                                                                        </option>
                                                                    ))}
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </div>
                                                </Col>
                        <Col xs={12}>
                                                    <div className='commonInput'>
                                                        <Form.Group controlId="month_name">
                                                            <Form.Label>Route Name</Form.Label>
                                                            <Form.Select
                                                                name="route_id"
                                                                id="route_id"
                                                                value={form.route_id}
                                                                onChange={(e) => setForm({ ...form, route_id: e.target.value })}>
                                                                <option value="">Select Route Name</option>
                                                                {(routers || [])
                                                                    //  .filter((router) => router.status === "Active")
                                                                    .map((router) => (
                                                                        <option key={router.router_id} value={router.router_id}>
                                                                            {router.route_name}
                                                                        </option>
                                                                    ))}
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </div>
                                                </Col>

                        <Col xs={12}>
                                                    <div className='commonInput'>
                                                        <Form.Group controlId="month_name">
                                                            <Form.Label>Driver Name</Form.Label>
                                                            <Form.Select
                                                                name="driver_id"
                                                                id="driver_id"
                                                                value={form.driver_id}
                                                                onChange={(e) => setForm({ ...form, driver_id: e.target.value })}>
                                                                <option value="">Select Driver Name</option>
                                                                {(drivers || [])
                                                                    //  .filter((driver) => driver.status === "Active")
                                                                    .map((driver) => (
                                                                        <option key={driver.emp_id} value={driver.emp_id}>
                                                                            {driver.emp_name}
                                                                        </option>
                                                                    ))}
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </div>
                                                </Col>

                      <Col xs={12}>
                                                    <div className='commonInput'>
                                                        <Form.Group controlId="month_name">
                                                            <Form.Label>Attender Name</Form.Label>
                                                            <Form.Select
                                                                name="attendor_id"
                                                                id="attendor_id"
                                                                value={form.attendor_id}
                                                                onChange={(e) => setForm({ ...form, attendor_id: e.target.value })}>
                                                                <option value="">Select Attender Name</option>
                                                                {(attenders || [])
                                                                    //  .filter((attender) => attender.status === "Active")
                                                                    .map((attender) => (
                                                                        <option key={attender.emp_id} value={attender.emp_id}>
                                                                            {attender.emp_name}
                                                                        </option>
                                                                    ))}
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </div>
                                                </Col>
                        
                       



                    </Row>
                </Modal.Body>
                <Modal.Footer className="modalFooterFixed">
                    <Button variant="secondary" className="btn-info clearBtn me-2" onClick={handleReset}>
                        Reset
                    </Button>
                    <div>
                        <Button variant="secondary" className="btn-danger secondaryBtn me-2" onClick={() => { handleCloseFilterModal(); }}>
                            Cancel
                        </Button>

                        <Button variant="primary" className="btn-success primaryBtn" onClick={handleSubmit}>
                            Search
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>

        </div>
    )
}

export default Busrouteassignment;
